<template>
  <div class="price-range-periods">
    <div class="period-item">
      <h6>Período referência</h6>
      <span class="pa-2">{{ formatDate(filters.reference_period_start) }} - {{ formatDate(filters.reference_period_end) }}</span>
    </div>
    <div class="period-item">
      <h6>Período atual</h6>
      <span class="pa-2">{{ formatDate(filters.period_start) }} - {{ formatDate(filters.period_end) }}</span>
    </div>
  </div>
</template>

<script>
import { DateTime } from 'luxon'
export default {
  name: 'PriceRangePeriods',
  props: {
    filters: {
      type: Object,
      default: () => {},
    },
  },
  data: () => ({
    DateTime,
  }),
  methods: {
    formatDate(date) {
      return DateTime.fromFormat(date, 'yyyy-MM-dd').toFormat('dd/MM/yyyy')
    },
  },
}
</script>

<style lang="scss" scoped>
.price-range-periods {
  display: flex;
  gap: 10px;
  margin-bottom: 8px;
  & .period-item {
    & h6 {
      font-size: 14px;
      color: $cinza-d10;
      font-weight: bold;
      margin-bottom: 4px;
    }

    & span {
      display: inline-block;
      color: $cinza-d10;
      font-size: 16px;
      font-weight: 400;
      background: $cinza-l70;
      border-radius: 4px;
    }
  }
}
</style>
